<template>
    <v-container v-if="authorization && authorization.superAdmin">
        <h1>Backoffice for PASS ACCOUNT</h1>
        <migration-card
            :title="'migrations.translationsTitle'"
            :db-name="'translations'"
            :module-name="'passAccount'"
        ></migration-card>
        <br /><br />
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
import MigrationCard from '../../components/MigrationCard.vue';
import { ACLCONFIG, AUTHORIZATION } from '../../constants/aclConfig';

export default {
    name: 'Home',
    components: {
        MigrationCard
    },
    computed: {
        ...mapState(ACLCONFIG, [AUTHORIZATION])
    },
    methods: {}
};
</script>
<style lang="scss" scoped></style>
